import React from "react";
import * as S from "./styles";


export const ValueSection = ({
  blocks
}) => {

  const renderWithBreaks = (text) => {
    if (!text) return null;
    return String(text).split(/\n+/).map((part, i, arr) => (
      <React.Fragment key={i}>
        {part}
        {i < arr.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <S.Wrapper>
      <S.SectionHead>
        <h2>
          Como criamos valor na prática
        </h2>
      </S.SectionHead>

      {/* Mobile: lista vertical */}
      <S.MobileList>
        {blocks.map((b, i) => (
          <S.MobileCard key={i}>
            <h3>{b.title}</h3>
            <p>{renderWithBreaks(b.text)}</p>
            <ul>
              {b.bullets.map((t, k) => (
                <li key={k}>
                  <span className="dot" />
                  <div className="li-content">
                    <strong>
                      {t.title}
                    </strong>
                    {t.text && <span className="sub">
                      {t.text}
                    </span>}
                  </div>
                </li>
              ))}
            </ul>
          </S.MobileCard>
        ))}
      </S.MobileList>

      {/* Desktop: imagem + texto alternando lados */}
      <S.TopShadow aria-hidden />
      <S.DesktopGrid>
        {blocks.map((b, i) => (
          <S.Row key={i} $reverse={i % 2 === 1}>
            <img src={b.img} alt={b.title} />

            <S.MobileCard key={i} className="texts">
              <h3>{b.title}</h3>
              <p>{renderWithBreaks(b.text)}</p>
              <ul>
                {b.bullets.map((t, k) => (
                  <li key={k}>
                    <span className="dot" />
                    <div className="li-content">
                      <strong>{t.title}</strong>
                      {t.text && <span className="sub">
                        {t.text}
                      </span>}
                    </div>
                  </li>
                ))}
              </ul>
            </S.MobileCard>
          </S.Row>
        ))}
      </S.DesktopGrid>
    </S.Wrapper>
  );
};
